import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    IconButton,
    HStack,
    Tooltip
} from '@chakra-ui/react';
import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    WhatsappShareButton,
    EmailShareButton,
    FacebookIcon,
    XIcon,
    PinterestIcon,
    WhatsappIcon,
    EmailIcon
} from 'react-share';
import {FaShareAlt, FaCopy} from 'react-icons/fa';
import {useAppToast} from "../../hooks/useAppToast";

const SharePopover = ({url, shareUrl, title, image, description}) => {
    const fbUrl = shareUrl || url;
    const toast = useAppToast();

    const copyLink = () => {
        navigator.clipboard.writeText(url);
        toast({
            title: 'Link został skopiowany!',
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
    };

    return (
        <Popover placement="top-end">
            <PopoverTrigger>
                <IconButton
                    aria-label="Udostępnij"
                    icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"></path>
                    </svg>}
                    borderRadius="full"
                    w={{ base: '44px', md: '48px' }}
                    h={{ base: '44px', md: '48px' }}
                    minW={{ base: '44px', md: '48px' }}
                    bg="white"
                    border="1px solid"
                    borderColor="surface.control"
                    color="ink.900"
                    _hover={{bg: 'surface.page'}}
                />
            </PopoverTrigger>
            <PopoverContent w="auto" bg="white" borderRadius="md" boxShadow="lg">
                <PopoverBody>
                    <HStack spacing={3}>
                        <FacebookShareButton url={fbUrl}>
                            <FacebookIcon size={32} round/>
                        </FacebookShareButton>

                        <TwitterShareButton url={url} title={title}>
                            <XIcon size={32} round/>
                        </TwitterShareButton>

                        <PinterestShareButton url={url} media={image} description={`${title} - ${description}`}>
                            <PinterestIcon size={32} round/>
                        </PinterestShareButton>

                        <WhatsappShareButton url={url} title={`${title}\n\n${description}`}>
                            <WhatsappIcon size={32} round/>
                        </WhatsappShareButton>

                        <EmailShareButton url={url} subject={title} body={`${description}\n\nSprawdź więcej na: `}>
                            <EmailIcon size={32} round/>
                        </EmailShareButton>

                        <Tooltip label="Kopiuj link">
                            <IconButton
                                icon={<FaCopy/>}
                                onClick={copyLink}
                                borderRadius="full"
                                bg="gray.400"
                                color="white"
                                _hover={{bg: 'gray.500'}}
                                size="sm"
                                aria-label="Kopiuj link"
                            />
                        </Tooltip>
                    </HStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
};

export default SharePopover;
